import React from "react";
import styled from "styled-components";
import { getParagraph14RegularTypography } from "../../../Typography";
import Avatar from "../../Avatar";
import { Truncate } from "../../styled";
import { IBadge } from "../../../commonTypes";
import StaticLink from "../../StaticLink/StaticLink";

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  cursor: pointer;
  margin: 5px;
`;

const DetailsContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  height: 100%;
  padding-left: 16px;
  justify-content: space-between;
  padding-top: 1px;
  padding-bottom: 1px;
`;

const Title = styled.div`
  ${getParagraph14RegularTypography};
  line-height: 16px;
  color: ${({ theme }) => theme.primaryColor};
  opacity: 0.7;
`;

const Subtitle = styled.p`
  ${getParagraph14RegularTypography};
  line-height: 16px;
  color: ${({ theme }) => theme.primaryColor};
  padding-right: 5px;
`;

const ArtistOwnerBadgeItem = ({ user, title, redirectUrl }: IBadge) => {
  return (
    <StaticLink href={redirectUrl}>
      <Root>
        <Avatar user={user} />
        <DetailsContainer>
          <Title>{title}</Title>
          <Truncate>
            <Subtitle>{user.username}</Subtitle>
          </Truncate>
        </DetailsContainer>
      </Root>
    </StaticLink>
  );
};

export default ArtistOwnerBadgeItem;
